import Filters from '../../components/filters/Filters';
import { ReactComponent as CloseIcon } from '../../assets/icons/trvto_closeWhite.svg';
import './mobileFilter.css';
import { useEffect, useState } from 'react';
import { fetchFiltersData } from './searchResultFun/fetchFilters';

// children: show these instead of the default filters (camp page uses CampFilters)
const MobileFilter = ({ filterData, onFilterChange, handleClose, showModal, prevFilters, type, children }) => {
    return (
        <>
            <div className='modal searchFilterModal'>
                <CloseIcon className='mobileFilterClose' onClick={handleClose} />
                <div className='modal-content'>
                    {children || (
                        <Filters
                            filterData={filterData}
                            onFilterChange={onFilterChange}
                            prevFilters={prevFilters}
                            type={type}
                        />
                    )}
                    <button type='button' onClick={handleClose} className='loginBtn'>
                        Apply
                    </button>
                </div>
            </div>
            {showModal && <div className='overlay filterOverlay' />}
        </>
    );
};

export default MobileFilter;
